import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49360b6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "counter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_ctx.store.businessId)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = () => _ctx.openBox()),
        id: "widget-open-button",
        class: "button-webchat fixed z-50 bottom-0 right-0 mb-5 mr-2.5",
        style: _normalizeStyle(`background-color: ${_ctx.store.data?.bgColor}`)
      }, [
        _createVNode(_component_Icon, {
          name: "chat",
          color: "white",
          size: "27"
        }),
        (_ctx.store.attendance.unreadMessages > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.store.attendance.unreadMessages), 1))
          : _createCommentVNode("", true)
      ], 4))
    : _createCommentVNode("", true)
}